module.exports = __webpack_public_path__ + "static/img/industry-sc.36a54059.png";